import React, { useState } from "react";

import { FaStore } from "react-icons/fa";

import { FiMapPin } from "react-icons/fi";
import { FaPhoneAlt } from "react-icons/fa";
import { FiFileText } from "react-icons/fi";
import { FaCalendarAlt } from "react-icons/fa";

const VendorDetailsCard = ({ vendor }) => {
  // Format date to be more readable
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  const [selectedImage, setSelectedImage] = useState(null);

  const handleImageClick = (image) => {
    setSelectedImage(image);
  };

  const handleCloseImageModal = () => {
    setSelectedImage(null);
  };

  const vendorInfo = [
    {
      icon: <FaStore className="w-4 h-4 text-gray-600" />,
      label: "Vendor Name",
      value: vendor.name,
    },
    {
      icon: <FaPhoneAlt className="w-4 h-4 text-gray-600" />,
      label: "Phone Number",
      value: vendor.phoneNumber,
    },
    {
      icon: <FiMapPin className="w-4 h-4 text-gray-600" />,
      label: "Address",
      value: vendor.address,
    },
    {
      icon: <FiMapPin className="w-4 h-4 text-gray-600" />,
      label: "City & PIN",
      value: `${vendor.city} - ${vendor.pin_code}`,
    },
    {
      icon: <FiFileText className="w-4 h-4 text-gray-600" />,
      label: "ID Proof Type",
      value: vendor.identity_proof_document_type,
    },
    {
      icon: <FiFileText className="w-4 h-4 text-gray-600" />,
      label: "ID Number",
      value: vendor.identity_proof_document_number,
    },
    {
      icon: <FaCalendarAlt className="w-4 h-4 text-gray-600" />,
      label: "Joined Date",
      value: formatDate(vendor.createdAt),
    },
  ];

  return (
    <div className="w-full bg-white shadow-sm rounded-lg">
      {/* Header */}
      <div className="px-6 py-4 border-b">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <img
              src={
                vendor?.avatar ||
                "https://th.bing.com/th/id/OIP.1mSyfMp-r01kxBYitbubbAHaHa?w=198&h=198&c=7&r=0&o=5&dpr=1.3&pid=1.7"
              }
              alt={`police verification`}
              onClick={() => handleImageClick(vendor?.avatar)}
              className="w-[40px] h-[40px] object-cover rounded-full border-2 border-[rgb(144 144 144)] shadow-md cursor-pointer mr-2 p-1 "
            />
            <h3 className="font-medium text-lg">Vendor Details</h3>
          </div>

          <div className="flex items-center space-x-2">
            <span
              className={`px-2 py-1 rounded-full text-xs ${
                vendor.available
                  ? "bg-green-100 text-green-800"
                  : "bg-red-100 text-red-800"
              }`}
            >
              {vendor.available ? "Available" : "Unavailable"}
            </span>
            <span
              className={`px-2 py-1 rounded-full text-xs ${
                vendor.disabled
                  ? "bg-red-100 text-red-800"
                  : "bg-green-100 text-green-800"
              }`}
            >
              {vendor.disabled ? "Disabled" : "Active"}
            </span>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="grid grid-cols-3 md:grid-cols-3 gap-6">
          {vendorInfo.map((info, index) => (
            <div key={index} className="flex items-start space-x-3">
              <div className="mt-1">{info.icon}</div>
              <div>
                <p className="text-sm font-medium text-gray-500">
                  {info.label}
                </p>
                <p className="text-sm text-gray-900">{info.value}</p>
              </div>
            </div>
          ))}
        </div>

        {vendor.location && (
          <div className="mt-6 pt-6 border-t">
            <h4 className="text-sm font-medium text-gray-500 mb-2">
              Store Location
            </h4>
            <div className="grid grid-cols-2 gap-4">
              <div>
                <p className="text-sm text-gray-500">Latitude</p>
                <p className="text-sm text-gray-900">{vendor.location.lat}</p>
              </div>
              <div>
                <p className="text-sm text-gray-500">Longitude</p>
                <p className="text-sm text-gray-900">{vendor.location.lng}</p>
              </div>
            </div>
          </div>
        )}
      </div>
      {selectedImage && (
        <div className="fixed inset-0 z-[150] flex items-center justify-center bg-gray-500 bg-opacity-75">
          <div className="relative w-fit h-full">
            <div
              className="mx-auto flex w-[35px] h-[35px] absolute right-4 top-4 flex-shrink-0 items-center justify-center rounded-full bg-red-100 cursor-pointer"
              onClick={handleCloseImageModal}
            >
              <svg
                className="h-6 w-6 text-red-600"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M6 6l12 12M6 18L18 6"
                />
              </svg>
            </div>
            <img
              src={selectedImage}
              alt="Selected"
              className="max-w-[100%] max-h-[100%] object-contain cursor-pointer"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default VendorDetailsCard;
